import BreadCrumb from "@/src/components/Shared/BreadCrumbs";
import { useIntl } from "react-intl";
import styles from "@/styles/projects.module.scss";
import Categories from "@/src/components/Home/Categories";
import server from "@/src/api/server";
import Seo from "@/src/components/Shared/Next-seo";
import { checkRedirect } from "@/src/components/helpers/functions";

const ProjectsPage = ({ personnelData, seoData }) => {
  const { formatMessage, locale } = useIntl();

  return (
    <div className={styles.projectsPage}>
      {seoData?.title?.[locale] && (
        <Seo
          title={seoData?.title?.[locale]}
          description={seoData?.description?.[locale]}
          keywords={seoData?.keywords?.[locale]}
        />
      )}
      <BreadCrumb
        heading={formatMessage({ id: "personnel" })}
        description={`${formatMessage({
          id: "main",
        })} / ${formatMessage({
          id: "personnel",
        })}`}
        background={personnelData?.breadCurmbImage}
      />

      <div className="container">
        <div className="row">
          <div className="details text-center py-5">
            <h2>{personnelData?.description?.[0]?.secTitle?.[locale]}</h2>
            <div className="desc">
              <div
                dangerouslySetInnerHTML={{
                  __html:
                    personnelData?.description?.[0]?.description?.[locale],
                }}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="projects-body swiper">
        <Categories data={personnelData} page="categories" />
      </div>
    </div>
  );
};

export async function getServerSideProps(ctx) {
  const redirect = await checkRedirect(ctx.resolvedUrl, ctx.req);
  if (redirect) return { redirect };

  const [homeResponse, personnelRes, seoPageResponse, personnelsRes] =
    await Promise.all([
      server.get("/pages/home"),
      server.get("/pages/personnel"),
      server.get("/pages/seo-data"),
      server.get("/personnels"),
    ]);

  const sectionData = (r) => r?.data?.data?.page?.sections || [];

  const seoData = sectionData(seoPageResponse)?.find(
    (section) => section?.pageName === "personnel"
  );
  const homeData = (section) =>
    sectionData(homeResponse)?.filter((e) => e?.slug == section)?.[0] || [];

  return {
    props: {
      personnelData: {
        ...homeData("personnel"),
        breadCurmbImage: homeData("intro")?.items[0]?.backgroundImage,
        description: personnelRes?.data?.data?.page?.sections || [],
        items: personnelsRes?.data?.data?.personnels || [],
      },
      seoData,
    },
  };
}

export default ProjectsPage;
